var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsitesAreaGuidesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.87 70.87"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.34 45.47c1.16 11.7-8.59 21.45-20.29 20.29-8.66-.86-15.66-7.86-16.52-16.52-1.16-11.7 8.59-21.45 20.29-20.29 8.66.86 15.66 7.86 16.52 16.52z",
    fill: "#f9d8cd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.77 24.86c1.16 11.7-8.59 21.45-20.29 20.29-8.66-.86-15.66-7.86-16.52-16.52-1.16-11.7 8.59-21.45 20.29-20.29 8.66.86 15.66 7.86 16.52 16.52z",
    fill: "#e84b0f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.12 10.7c-8.93-8.93-23.44-8.93-32.37 0-8.93 8.93-8.93 23.44 0 32.37l16.18 16.18 16.18-16.18c8.93-8.96 8.93-23.44 0-32.37zM35.93 39.24c-6.83 0-12.36-5.53-12.36-12.36s5.53-12.36 12.36-12.36 12.36 5.53 12.36 12.36-5.53 12.36-12.36 12.36z",
    fill: "#fff",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}
export default SvgWebsitesAreaGuidesIcon;